<div class="content-container">
  <div class="empty-content-container" *ngIf="!userDashboards.length && !isLoading; else content">
    <img src="assets/icons/empty_dashboard_v2.svg" alt="empty-icon">
    <div class="title">Ready to create your first dashboard? 🚀</div>
    <div class="sub-title">Get started by clicking on the button below.</div>
    <button class="btn-create-dashboard common-button" (click)="handleCreateDashboard()">
      <span>Create Dashboard</span>
    </button>
  </div>

  <ng-template #content>
    <div class="dashboard-content">
      <div class="dashboard-header">
        <div class="search-container">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="search-icon">
            <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <input
            type="text"
            class="search-input"
            placeholder="Search dashboard..."
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
            [disabled]="isLoading" />
        </div>
        <div class="dashboard-actions">
          <button class="btn-refresh" (click)="handleRefresh()" [disabled]="isLoading">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.00008 2.66675V0.666748L5.33341 3.33341L8.00008 6.00008V4.00008C10.2067 4.00008 12.0001 5.79341 12.0001 8.00008C12.0001 8.67341 11.8334 9.31342 11.5334 9.86675L12.5067 10.8401C13.0267 10.0201 13.3334 9.04675 13.3334 8.00008C13.3334 5.05341 10.9467 2.66675 8.00008 2.66675ZM8.00008 12.0001C5.79341 12.0001 4.00008 10.2067 4.00008 8.00008C4.00008 7.32675 4.16675 6.68675 4.46675 6.13341L3.49341 5.16008C2.97341 5.98008 2.66675 6.95341 2.66675 8.00008C2.66675 10.9467 5.05341 13.3334 8.00008 13.3334V15.3334L10.6667 12.6667L8.00008 10.0001V12.0001Z" fill="#1E2225"/>
            </svg>
            <span>Refresh</span>
          </button>
          <button class="btn-create" (click)="handleCreateDashboard()">
            <span>+ Create</span>
          </button>
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="isLoading" class="dashboard-loading">
        <div class="loading-spinner"></div>
        <p>Loading dashboards...</p>
      </div>

      <!-- Search No Results -->
      <div *ngIf="!isLoading && userDashboards.length > 0 && filteredDashboards.length === 0 && searchQuery.trim() !== ''" class="search-no-results">
        <p>No dashboards found matching "{{ searchQuery }}"</p>
      </div>

      <!-- Dashboard Cards Grid -->
      <div *ngIf="!isLoading && userDashboards.length > 0 && filteredDashboards.length > 0" class="dashboard-cards-grid">
        <div
          class="dashboard-card"
          *ngFor="let dashboard of filteredDashboards"
          [class.selected]="selectedDashboard?.id === dashboard.id"
          (click)="handleCardClick(dashboard)"
          (dblclick)="handleCardDoubleClick(dashboard)">
          <div class="card-header">
            <div class="card-icon-wrapper">
              <div class="card-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z" fill="currentColor"/>
              </svg>
              </div>
            </div>
            <div class="card-header-right">
              <div class="shared-badge"
                   *ngIf="dashboard.is_shared || dashboard.is_shared_with_all">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="shared-icon">
                  <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span class="shared-text">Shared</span>
              </div>
              <div class="card-actions-menu" (click)="$event.stopPropagation()">
                <button
                  class="card-more-btn"
                  type="button"
                  (click)="toggleCardMenu($event, dashboard)">
                  <img src="assets/icons/three-dots.svg" alt="more options" />
                </button>
                <div class="card-menu-dropdown" *ngIf="selectedMenuDashboard?.id === dashboard.id && showCardMenu" (click)="$event.stopPropagation()">
                  <button class="menu-item" type="button" (click)="handleCardShare($event, dashboard)">
                    <img src="assets/icons/user-dashbaord/share-dashboard.svg" alt="share" class="menu-icon" />
                    <span>{{ (dashboard.is_shared || dashboard.is_shared_with_all) ? 'Unshare' : 'Share' }}</span>
                  </button>
                  <button class="menu-item delete-item" type="button" (click)="handleCardDelete($event, dashboard)">
                    <img src="assets/icons/user-dashbaord/delete-chart.svg" alt="delete" class="menu-icon" />
                    <span>Delete</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <h3
              class="card-title"
              [matTooltip]="shouldShowTooltip(dashboard.name) ? dashboard.name : ''"
              [matTooltipDisabled]="!shouldShowTooltip(dashboard.name)"
              matTooltipPosition="above">
              {{ dashboard.name }}
            </h3>
            <div class="card-stats">
              <div class="stat-item" *ngIf="dashboard.user_email || dashboard.generated_by_email">
                <span class="stat-label">Created by</span>
                <span class="stat-value">{{ formatEmail(dashboard.user_email || dashboard.generated_by_email) }}</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="card-date">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 4H5C3.89 4 3 4.9 3 6V20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20Z" fill="currentColor"/>
              </svg>
              <span *ngIf="dashboard.updated_at">
                <span>Last updated: {{ formatDate(dashboard.updated_at) }}</span>
                <span *ngIf="dashboard.updated_by_email"> by {{ formatEmail(dashboard.updated_by_email) }}</span>
              </span>
              <span *ngIf="!dashboard.updated_at && dashboard.created_at">
                <span>Last updated: {{ formatDate(dashboard.created_at) }}</span>
                <span *ngIf="dashboard.user_email || dashboard.generated_by_email"> by {{ formatEmail(dashboard.user_email || dashboard.generated_by_email) }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Selected Dashboard View -->
      <div class="selected-dashboard-view" *ngIf="selectedDashboard">
        <div class="selected-header">
          <div class="selected-info">
            <h3>{{ selectedDashboard.name }}</h3>
            <div class="shared-badge"
                 *ngIf="selectedDashboard.is_shared || selectedDashboard.is_shared_with_all">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="shared-icon">
                <path d="M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 14C8.13401 14 5 17.134 5 21H19C19 17.134 15.866 14 12 14Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="shared-text">Shared</span>
            </div>
          </div>
          <button class="btn-edit" (click)="handleCardEdit($event, selectedDashboard)">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.33333 13.35C0.966667 13.35 0.652778 13.2194 0.391667 12.9583C0.130556 12.6972 0 12.3833 0 12.0167V2.68333C0 2.31667 0.130556 2.00278 0.391667 1.74167C0.652778 1.48056 0.966667 1.35 1.33333 1.35H7.28333L5.95 2.68333H1.33333V12.0167H10.6667V7.38333L12 6.05V12.0167C12 12.3833 11.8694 12.6972 11.6083 12.9583C11.3472 13.2194 11.0333 13.35 10.6667 13.35H1.33333ZM4 9.35V6.51667L10.1167 0.4C10.25 0.266667 10.4 0.166667 10.5667 0.1C10.7333 0.0333333 10.9 0 11.0667 0C11.2444 0 11.4139 0.0333333 11.575 0.1C11.7361 0.166667 11.8833 0.266667 12.0167 0.4L12.95 1.35C13.0722 1.48333 13.1667 1.63056 13.2333 1.79167C13.3 1.95278 13.3333 2.11667 13.3333 2.28333C13.3333 2.45 13.3028 2.61389 13.2417 2.775C13.1806 2.93611 13.0833 3.08333 12.95 3.21667L6.83333 9.35H4ZM5.33333 8.01667H6.26667L10.1333 4.15L9.66667 3.68333L9.18333 3.21667L5.33333 7.06667V8.01667Z" fill="#1E2225"/>
            </svg>
            <span>Edit</span>
          </button>
        </div>
        <div class="dashboard-grid" *ngIf="!isLoadingDashboard">
          <div *ngIf="!selectedDashboard.charts || selectedDashboard.charts.length === 0" class="dashboard-empty">
            <p>No charts in this dashboard. Click Edit to add charts.</p>
          </div>
          <div class="chart-placeholder" *ngFor="let chart of selectedDashboard.charts; trackBy: trackByChartId">
            <app-chart-overview [chartData]="chart"></app-chart-overview>
          </div>
        </div>
        <div *ngIf="isLoadingDashboard" class="dashboard-loading">
          <div class="loading-spinner"></div>
          <p>Loading dashboard...</p>
        </div>
      </div>
    </div>
  </ng-template>
</div>
